/**
 * Which form of a "one|few|many" template applies to `count`. Uzbek has no plural after a
 * number (one form); English has two; Russian has three.
 */
export function pluralIndex(lang, count) {
  const n = Math.abs(Number(count) || 0);
  if (lang === 'ru') {
    const m10 = n % 10;
    const m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return 0;
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return 1;
    return 2;
  }
  if (lang === 'en') return n === 1 ? 0 : 1;
  return 0;
}

/** "{n} lesson|{n} lessons" -> the right half for `count`. A template with no bar is returned whole. */
export function pickPlural(template, count, lang) {
  const forms = String(template).split('|');
  return forms[Math.min(pluralIndex(lang, count), forms.length - 1)];
}
